<template>
   <section >
       <h5>{{item.name}}</h5>
        <p><strong>VARIANT:</strong> {{item.variant_title}}</p>

       <b-form @submit="onSubmit" @reset="onReset" > 
        
        <b-form-group >
            <b-form-select class="m-b-20"  v-model="item.selected" :options="itemOptions" @change="showOrHideExtraFields"></b-form-select>
        </b-form-group>

        <div v-show="showExtras">
          <b-form-group label="Add note:" >
            <b-form-textarea
              id="textarea"
              v-model="item.note"
              placeholder="Add optional note..."
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>

          
  
          <b-form-group>
            <b-button size="sm" type="submit" variant="primary" class="m-r-10">Submit</b-button>
            <b-button size="sm" type="reset" variant="danger">Cancel</b-button>
          </b-form-group>
        </div>

       </b-form>

        <ul class="status-ul" v-if="itemStatuses.length > 0">
          <li :style="{backgroundColor: status.OrdersAndItemsStatus.colorCode}" v-for="(status, index) in itemStatuses" v-bind:key="index" :class="{'deleted': status.deletedAt}">
             <div class="pulsating-circle" v-if="status.lastSetStatus"></div>
            <div class="status-header"><div>
            {{status.serialNo}}
          </div> <div>
            Doer: {{ status.doer.username}}
          </div></div><strong :style="{color: status.OrdersAndItemsStatus.colorCode}">{{ status.OrdersAndItemsStatus.title }}</strong> <div v-if="status.note" class="note-icon" v-b-tooltip.hover :title="status.note" size="xs"><b-icon icon="card-text" font-scale="1.5"></b-icon></div> <span>{{ status.createdAt | moment("dddd, MMMM Do YYYY, h:mm:ss a") }} </span>

          <div class="clearfix">
            <b-dropdown split id="dropdown-dropright" dropright text="Actions" variant="primary" size="xs" class="m-2 float-right custom-dropdown" v-if="!status.deletedAt">
              <b-dropdown-item href="#" @click.prevent="deleteStatus(status.id)">Delete Status</b-dropdown-item>
            </b-dropdown>
            <div v-else class="text-right deletedBy">
              Deleted By: {{ status.deletedBy.username }}
            </div>
          </div>
          </li>
        </ul>
      <div v-else class="no-status">No status set yet.</div>
  </section>
</template>

<script>
 import EventBus from '../../../EventBus'
 import OrderAndItemStatusMixin from './order-and-item-status-mixin';

 
  export default {
     data(){
       return {
         item: this.itemData,
         showExtras: false
       }
     },
     props: ['itemData', 'itemOptions', "showAll"],
     mixins: [OrderAndItemStatusMixin],
     methods: {
       itemStatus(id, selected, recordType, item={}, orderId, note, statusName){
          EventBus.$emit('order-item-status-updated', {
             id, selected, recordType, item, orderId, note, statusName
          })
       },
       onSubmit(evt){

         evt.preventDefault();
        
         // send the status title
         let statusName = 'Testing'
         let selectedStatusTitle = this.itemOptions.find(status => {
            return status.value == this.item.selected
         })

         console.log('Selected status', this.item.selected)
    
         if(selectedStatusTitle){
            statusName = selectedStatusTitle.text.trim()
         }

         this.itemStatus(this.item.id, this.item.selected, 'Item', this.item, this.item.shopify_order_id, this.item.note, statusName);

         this.showExtras = false;
         this.item.note = '';
         this.item.selected = null;

       },
       onReset(evt){
         evt.preventDefault();

         this.item.note = '';
         this.item.selected = null;
         this.showExtras = false;
       },
       showOrHideExtraFields(){
          this.showExtras = this.item.selected ? true : false
       }
     },
     computed: {
        itemStatuses(){
            console.log("Calculating")
            if(this.showAll){
               console.log("entered if")
               return this.itemData.statuses
            }
            else{
              console.log("entered else")
              return this.itemData.statuses.filter(status => {
                 return !status.deletedAt
              })
            }
        }
     }
  }
</script>

<style lang="scss" scoped>
  .deleted{
    opacity: 0.8;
    position: relative;

    &::after{
      position: absolute;
      content: "Deleted";
      border: 1px solid rgb(255, 255, 255);
      font-size: 16px;
      text-transform: uppercase;
      top: 50%;
      left: 50%;
      padding: 10px 15px;
      transform: translate(-50%, -50%) rotate(-20deg) scale(1);
      -webkit-filter: none !important;
      background-color: red;
      transform-origin: center;
      animation: scalingAnimation 1s alternate infinite ease-in;
    }
  }
  @keyframes scalingAnimation {
    0% { transform: scale(0.8) translate(-50%, -50%) rotate(-20deg); }
    100% { transform: scale(1) translate(-50%, -50%) rotate(-20deg); }
  }
  .deletedBy{
    font-size: 13px;
  }
</style>